import { GET_DASHBOARD_LIST } from './getDashboardList';

export const externalDashboardsApi = {
  getDashboardList: GET_DASHBOARD_LIST,
};

export * from './types';
export * from './admin';
